import React from 'react'
import * as d3 from "../d3.modified.js"
import {TemplatesLib} from '../TemplatesLib'
import Utils from '../Utils'

export default class TaskNode extends React.PureComponent {
    constructor(props) {
        super(props)
        this.props.nodeItem.refs = {}
        this.props.nodeItem.refs.fields = {}
        this.props.nodeItem._jsx = {
            styleSelect: this.styleSelect,
            styleDeselect: this.styleDeselect,
            styleMove: this.styleMove,
            styleResize: this.styleResize,
            styleFade: this.styleFade,
            styleLinked: this.styleLinked,
            destyleLinked: this.destyleLinked,
            dom: this,
        }
    }

    styleLinked = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'linkedto',
            val: true,
        })
    }

    destyleLinked = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'linkedto',
            val: false,
        })
    }

    componentWillReceiveProps() {
        this.forceUpdate()
    }

    componentDidMount() {
        var node = this.props.nodeItem
        this.position = undefined
        this.props.nodeItem.isJustClickNotDrag = false

        const _step = 10

        if (node._selectionId!==-1) {
            this.styleSelect()
        }

        node.refs.holder
            .transition()
                .duration(500)
                .style('opacity', 1)

        if (this.props.edit) {
            node.refs.resizer.call(d3.drag()
                .on('start', ()=>{
                    node.resizeData = {
                        width: node.width,
                        height: node.height,
                        x: d3.event.x,
                        y: d3.event.y
                    }
                    this.props.clickHandler(node, false)
                })
                .on('drag', ()=>{
                    let oldWidth = node.width
                    var newWidth = (d3.event.x-node.resizeData.x) + node.resizeData.width
                    if (newWidth>90 && newWidth<700) {
                        if (this.props.keyPressDict.grid) {
                            node.width = Math.floor(newWidth/_step)*_step
                        } else {
                            node.width = newWidth
                        }
                    }
                    // var newHeight = (d3.event.y-node.resizeData.y) + node.resizeData.height
                    // if (newHeight>this.minHeight && newHeight<250) {
                    //     if (this.props.keyPressDict.grid) {
                    //         node.height = Math.floor(newHeight/_step)*_step
                    //     } else {
                    //         node.height = newHeight
                    //     }

                    // }
                    this.styleResize()
                    this.props.dragHandler((node.width-oldWidth)*0.5, 0)
                    this.props.resizeHandler(node.width, node.height, node.id)
                })
                .on('end', ()=>{
                    this.props.dragEndHandler()
                    this.props.resizeEndHandler(node)
                    //this.props.dragEndHandler()
                    this.props.resizeEndHandler()
                    this.styleResize()
                    this.props.dragEndHandler()
                    this.props.resizeEndHandler(node)
                })
            )

            node.refs.holder.call(d3.drag()
                .on('start', ()=>{
                    this.position = {x:d3.event.x, y:d3.event.y}
                    this.props.hideCtxMenus()

                    // <grided>
                    this.startDragMPosX = d3.event.x
                    this.startDragMPosY = d3.event.y
                    this.startDragPosX = node.x
                    this.startDragPosY = node.y
                    // </grided>

                    this.props.dragStartHandler()
                })
                .on('drag', ()=>{
                    node.refs.holder.classed('moving', true)
                    if (node._selectionId === -1) {
                        this.props.clickHandler(node, true)
                    }
                    if ((!this.props.keyPressDict.link || (this.props.keyPressDict.link && node._selectionId!==-1)) && (!this.props.keyPressDict.ctrl || node._selectionId !== -1)) {

                        // <grided>
                        if (this.props.keyPressDict.grid) {
                            let x = this.startDragPosX + (d3.event.x-this.startDragMPosX)-node.width*0.5
                            let y = this.startDragPosY + (d3.event.y-this.startDragMPosY)-node.height*0.5
                            x = parseInt((x+_step/2)/_step)*_step
                            y = parseInt((y+_step/2)/_step)*_step

                            let dx = x-node.x+node.width*0.5
                            let dy = y-node.y+node.height*0.5
                            this.props.dragHandler(dx, dy)
                        } else {
                        // </grided>
                            this.props.dragHandler(d3.event.dx, d3.event.dy)
                        }
                    }
                })
                .on('end', ()=>{
                    node.refs.holder.classed('moving', false)
                    let newPosition = {x:d3.event.x, y:d3.event.y}
                    if ((newPosition.x !== this.position.x) || (newPosition.y !== this.position.y) ) {
                        this.props.dragEndHandler()
                    }
                })
            )
        }

        node.refs.holder
            .on('mouseenter', ()=>{
                if (this.props.keyPressDict.link) {
                    if (this.props.canCreateLink(node)) {
                        node.refs.holder.classed('linkage-can', true)
                    } else {
                        node.refs.holder.classed('linkage-cannot', true)
                    }
                }
            })
            .on('mouseleave', ()=>{
                if (this.props.keyPressDict.link) {
                    node.refs.holder.classed('linkage-can', false)
                    node.refs.holder.classed('linkage-cannot', false)
                }
            })


        node.refs.holder
            .on("click", ()=>{
                if (this.props.keyPressDict.link && this.props.edit) {
                    this.props.createLink(node)
                } else {
                    this.props.clickHandler(node)
                }
                d3.event.stopPropagation()
            })
    }

    styleMove = () => {
        var node = this.props.nodeItem
        this.props.enqueueAttrChange({
            elem: node.refs.holder,
            attr: 'transform',
            val: `translate(${node.x-node.width/2} ${node.y-node.height/2})`
        })
    }

    styleResize = () => {
        var node = this.props.nodeItem

        var _ = (a,b,c) => {this.props.enqueueAttrChange({elem:a,attr:b,val:c})}

        _(node.refs.holder, 'transform', `translate(${node.x-node.width/2} ${node.y-node.height/2})`)
        _(node.refs.background, 'width', node.width)
        _(node.refs.background, 'height', node.height)
        _(node.refs.shadow, 'width', node.width)
        _(node.refs.shadow, 'height', node.height)

        _(node.refs.fields.title, 'width', node.width-20)
        if (node.refs.fields.tags) {
            _(node.refs.fields.tags, 'width', node.width-10)
        }
        if (node.refs.fields.assignees) {
            _(node.refs.fields.assignees, 'width', node.width-10)
        }
        _(node.refs.resizer, 'x', node.width-10)
        // _(node.refs.resizer, 'y', node.height-10)
        _(node.refs.holder, 'transform', `translate(${node.x-node.width/2} ${node.y-node.height/2})`)
    }

    // styleHover = () => {
    //     var node = this.props.nodeItem
    //     this.props.enqueueClassChange({
    //         elem: node.refs.holder,
    //         class: 'hovered',
    //         val: true,
    //     })
    // }

    styleSelect = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'active',
            val: true,
        })
    }

    styleDeselect = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'active',
            val: false,
        })
    }

    styleFade = () => {
        this.props.nodeItem.refs.holder
            .transition()
                .duration(400)
                .style('opacity', 0)
    }

    render() {
        var node = this.props.nodeItem

        const diffColors = {
            none: "#fff",
            yellow: "#FFFFE6",
            green: "#E6FFED",
            red: "#FFEEF0"
        }

        this.minHeight = 15



        let hasDescription = (node.properties.description!=="")
        let hasLikes = (node.properties.likes>0)
        let hasFiles = (node.properties.files.length>0)
        let hasComments = (node.comments>0)

        let hasTags = (node.properties.tags.length>0)
        let tagsY = 32 + ((hasDescription||hasLikes||hasFiles||hasComments)?25:0)

        let hasAssignees = (node.properties.assignees.length>0)
        let assigneesY = tagsY + (hasTags?25:0)

        node.height = 40 + ((hasDescription||hasLikes||hasFiles||hasComments)?25:0) + (hasTags?25:0) + (hasAssignees?25:0)

        return (
            <g
                className="node-holder node-superref-holder"
                transform={`translate(${node.x-node.width/2} ${node.y-node.height/2})`}
                ref={c=>node.refs.holder=d3.select(c)}
                opacity="0"
            >
            {/* BACKGROUND */}
                <rect
                    className="node-superref-shadow"
                    width={node.width}
                    height={node.height}
                    x="1.5"
                    y="1.5"
                    rx="3"
                    ry="3"
                    ref={c=>node.refs.shadow=d3.select(c)}
                />
                <rect
                    className="node-superref-background"
                    id={`N_${node.id}_bg`}
                    width={node.width}
                    height={node.height}
                    rx="3"
                    ry="3"
                    ref={c=>node.refs.background=d3.select(c)}
                    // style={{fill: node._compareType?diffColors[node._compareType]:node.properties.color}}
                />
            {/* TITLE */}
                <foreignObject x="10" y="10" width={node.width-20} height="45" ref={c=>node.refs.fields['title']=d3.select(c)} style={{pointerEvents: 'none'}}>
                    <div xmlns="http://www.w3.org/1999/xhtml" className={`node-field-medium neverovatno`}>
                        {node.properties.title?node.properties.title:'(untitled)'}
                    </div>
            {/* DESCRIPTION */}
                {
                    (hasDescription)
                        ? <span className="node-field-icon">
                            <svg width="16" height="16" viewBox="0 0 20 20">
                                <path fill="#888" d="M17.5 5h-15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h15c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                <path fill="#888" d="M17.5 8h-11c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h11c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                <path fill="#888" d="M17.5 11h-15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h15c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                <path fill="#888" d="M17.5 14h-11c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h11c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                <path fill="#888" d="M17.5 17h-15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h15c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                            </svg>
                        </span>
                        : null
                }
            {/* LIKES */}
                {
                    (hasLikes)
                        ? <span className="node-field-icon">
                            <svg width="16" height="16" viewBox="0 0 20 20">
                                <path fill="#888" d="M18.916 11.208c0.443-0.511 0.695-1.355 0.695-2.159 0-0.531-0.115-0.996-0.333-1.345-0.284-0.454-0.738-0.704-1.278-0.704h-2.618c1.425-2.591 1.785-4.543 1.070-5.807-0.499-0.881-1.413-1.193-2.045-1.193-0.25 0-0.462 0.185-0.495 0.433-0.179 1.319-1.188 2.893-2.768 4.318-1.514 1.365-3.374 2.456-5.286 3.11-0.241-0.508-0.758-0.86-1.356-0.86h-3c-0.827 0-1.5 0.673-1.5 1.5v9c0 0.827 0.673 1.5 1.5 1.5h3c0.634 0 1.176-0.395 1.396-0.952 1.961 0.246 2.699 0.64 3.414 1.022 0.895 0.478 1.739 0.93 4.503 0.93 0.72 0 1.398-0.188 1.91-0.529 0.5-0.333 0.82-0.801 0.926-1.343 0.399-0.162 0.753-0.536 1.024-1.092 0.264-0.541 0.435-1.232 0.435-1.761 0-0.099-0.006-0.19-0.017-0.274 0.253-0.186 0.48-0.473 0.667-0.851 0.27-0.545 0.432-1.228 0.432-1.826 0-0.424-0.079-0.777-0.234-1.051-0.013-0.022-0.026-0.044-0.039-0.065zM4.5 18h-3c-0.276 0-0.5-0.224-0.5-0.5v-9c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v8.999c0 0 0 0.001 0 0.001-0 0.276-0.224 0.5-0.5 0.5zM18.339 10.274c-0.151 0.304-0.304 0.414-0.37 0.414-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.042 0 0.072 0 0.117 0.078 0.066 0.117 0.104 0.32 0.104 0.558 0 0.445-0.126 0.974-0.328 1.382-0.198 0.399-0.399 0.544-0.487 0.544-0.276 0-0.5 0.224-0.5 0.5 0 0.177 0.092 0.333 0.231 0.422 0.031 0.317-0.117 1.165-0.501 1.718-0.145 0.209-0.298 0.329-0.418 0.329-0.276 0-0.5 0.224-0.5 0.5 0 0.88-0.972 1.281-1.875 1.281-2.513 0-3.217-0.376-4.032-0.812-0.762-0.407-1.618-0.865-3.781-1.134v-8.187c2.101-0.689 4.152-1.877 5.812-3.373 1.593-1.436 2.639-2.988 2.994-4.426 0.272 0.087 0.579 0.271 0.776 0.618 0.334 0.59 0.584 2.096-1.493 5.557-0.093 0.154-0.095 0.347-0.006 0.504s0.255 0.254 0.435 0.254h3.483c0.199 0 0.327 0.070 0.43 0.234 0.117 0.187 0.181 0.477 0.181 0.815 0 0.424-0.102 0.882-0.272 1.225z"/>
                            </svg> {Utils.parseAmount(node.properties.likes)}
                        </span>
                        : null
                }
            {/* ATTACHMENTS */}
                {
                    (hasFiles)
                        ? <span className="node-field-icon">
                            <svg width="16" height="16" viewBox="0 0 20 20">
                                <path fill="#888" d="M9.5 20c-2.481 0-4.5-2.019-4.5-4.5v-12c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5v11c0 1.378-1.122 2.5-2.5 2.5s-2.5-1.122-2.5-2.5v-6c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v6c0 0.827 0.673 1.5 1.5 1.5s1.5-0.673 1.5-1.5v-11c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5v12c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5v-7c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v7c0 2.481-2.019 4.5-4.5 4.5z" />
                            </svg> {Utils.parseAmount(node.properties.files.length)}
                        </span>
                        : null
                }
            {/* COMMENTS */}
                {
                    (hasComments)
                        ? <span className="node-field-icon">
                            <svg width="16" height="16" viewBox="0 0 20 20">
                                <path fill="#888" d="M0.5 19c-0.225 0-0.422-0.15-0.482-0.367s0.032-0.447 0.225-0.562c1.691-1.014 2.392-2.489 2.641-3.179-1.838-1.407-2.884-3.354-2.884-5.392 0-1.029 0.258-2.026 0.768-2.964 0.486-0.894 1.18-1.695 2.061-2.381 1.787-1.39 4.156-2.156 6.671-2.156s4.884 0.766 6.671 2.156c0.881 0.685 1.575 1.486 2.061 2.381 0.51 0.937 0.768 1.934 0.768 2.964s-0.258 2.026-0.768 2.964c-0.486 0.894-1.18 1.695-2.061 2.381-1.787 1.39-4.156 2.156-6.671 2.156-1.033 0-2.047-0.129-3.016-0.385-0.429 0.286-1.231 0.793-2.189 1.27-1.488 0.74-2.764 1.115-3.794 1.115zM9.5 3c-4.687 0-8.5 2.916-8.5 6.5 0 1.815 1.005 3.562 2.756 4.792 0.172 0.121 0.25 0.336 0.196 0.539-0.117 0.436-0.515 1.633-1.58 2.788 1.302-0.456 2.704-1.247 3.739-1.959 0.123-0.085 0.277-0.11 0.421-0.069 0.948 0.271 1.947 0.409 2.968 0.409 4.687 0 8.5-2.916 8.5-6.5s-3.813-6.5-8.5-6.5z"/>
                            </svg> {Utils.parseAmount(node.comments)}
                        </span>
                        : null
                }
                </foreignObject>
            {/* TAGS */}
                {
                    (hasTags)
                        ? (
                            <foreignObject x="10" y={tagsY} width={node.width-10} height="30" ref={c=>node.refs.fields['tags']=d3.select(c)} style={{pointerEvents: 'none'}}>
                                {
                                    node.properties.tags.map(
                                        (tag, id) => <div key={tag+id} className={`node-field-tag ${tag.replace(/[\s\/]/,'_').toLowerCase()}`}>{tag}</div>
                                    )
                                }
                            </foreignObject>
                        )
                        : null
                }

            {/* ASSIGNEES */}
                {
                    (hasAssignees)
                        ? (
                            <foreignObject x="10" y={assigneesY} width={node.width-10} height="30" ref={c=>node.refs.fields['assignees']=d3.select(c)} style={{pointerEvents: 'none'}}>
                                {
                                    node.properties.assignees.map(
                                        (assignee, id) => <div key={assignee+id} className={`node-field-assignee ${assignee}`}></div>
                                    )
                                }
                            </foreignObject>
                        )
                        : null
                }

            {/* RESIZE */}
                <rect
                    display={this.props.edit ? "default" : "none"}
                    x={node.width-10}
                    y={node.height-10}
                    width="10"
                    height="10"
                    className="node-superref-resizer"
                    ref={c=>node.refs.resizer=d3.select(c)}
                />
            </g>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/nodes/TaskNode.js